import { render, staticRenderFns } from "./ProfileHelpForms.vue?vue&type=template&id=727f7d90&"
import script from "./ProfileHelpForms.vue?vue&type=script&lang=js&"
export * from "./ProfileHelpForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports